export const handleCustomError = (err: any, defaultMessage = 'Error making request'): string => {
  const error = err.errors ? err.errors[0].message : err.message;

  return error || defaultMessage;
};
